import { i18n, Row, Form, RichEditor, Cell } from "@common";
import { useState, useRef, useEffect } from "react";

const Preview = (props) => {
    const { status, item } = props;

    const button = [
        {
            text: i18n.get('Common_Close_Entry'),
            classify: 'theme',
            name: 'close',
            onClick: () => { }
        }
    ];

    return (
        <R.Panel
            id="panel-email-template-preview"
            title={i18n.get("CIS_Admin_EmailTemplate_Preview_Entry")}
            status={status}
            buttons={button}>
            <ViewItem item={item} />
        </R.Panel>
    );
};
function ViewItem(props) {
    const { item } = props;
    const aboutRef = useRef();
    useEffect(() => {
        if (item) {
            aboutRef?.current.updateValue(item.content);
        }
    }, [item]);

    return (
        <>
            <Form overview>
                <Row>
                <Cell label={i18n.get('CIS_Admin_EmailTemplate_Subject_Entry')} required validation="Input">
                    {item.title}
                </Cell>
                <Cell label={i18n.get('CIS_Admin_EmailTemplate_TemplateType_Entry')} required validation="Input">
                    {item?.id?.indexOf('OTP') != -1 ? i18n.get('CIS_Admin_EmailTemplate_OTP_Entry') : i18n.get('CIS_Admin_EmailTemplate_Welcome_Entry')}
                </Cell>
                </Row>

            </Form>
            <RichEditor
                plainText={true}
                id='richeditor-body'
                ref={aboutRef}
                height='auto'
                value={item.content}
                disabled={true}
                attrs={{ 'aria-labelledby': Form.formlabel }}
            />
        </>
    );
}

export default Preview;